import {Layout, Button, Carousel, Tabs, FloatButton, Affix} from 'antd';
import {QuestionCircleOutlined} from '@ant-design/icons';
import {useEffect, useState} from 'react';
import './ContentIndex.css';
const logoImg = 'https://zjcnas.oss-cn-hangzhou.aliyuncs.com/images/logo2.png';
const jieshao = 'https://zjcnas.oss-cn-hangzhou.aliyuncs.com/images/xq/cnas介绍图片.jpg';
const liucheng = 'https://zjcnas.oss-cn-hangzhou.aliyuncs.com/images/xq/cnas流程图.jpg';
const yemei = 'https://zjcnas.oss-cn-hangzhou.aliyuncs.com/images/cnas.jpg';
const xia = 'https://zjcnas.oss-cn-hangzhou.aliyuncs.com/images/xq/logo至于每一个介绍最下方.png';
const logo22 = 'https://zjcnas.oss-cn-hangzhou.aliyuncs.com/images/logo22.png';
const weixing = 'https://zjcnas.oss-cn-hangzhou.aliyuncs.com/images/weixing.jpg';
const {Header, Footer, Sider, Content} = Layout;
const App = () => {
    useEffect(() => {
        // 配置swiper播放 配置项都写这里面
        // console.log(1232112312)
        // const mySwiper = new Swiper('.swiper', {
        //     autoplay: true,
        //     loop: true
        // })
        window.scrollTo(0, 0);
        // function handleScroll() {
        //     setScrollPosition(window.scrollY); // 获取垂直滚动位置
        // }
        //
        // window.addEventListener('scroll', handleScroll);
        //
        // return () => {
        //     // 清除事件监听器以避免内存泄漏
        //     window.removeEventListener('scroll', handleScroll);
        // };
    }, [])
    const [scrollPosition, setScrollPosition] = useState(0);
    const [top, setTop] = useState(118);
    const scroll=(y)=>{
        window.scrollTo(0, y);
    }

    function createMarkup() {
        return {
            __html: `<div class="nyrcon">
                    <div class="nyrt"><span>CNAS实验室认可咨询</span></div>
                    <div class="nxm_xq">
                        <div class="nxcon">
                            <p style="text-align: left;"><span style="font-size: 16px; font-family: arial, helvetica, sans-serif; color: rgb(0, 0, 0);"><strong><span style="font-family: arial, helvetica, sans-serif; font-size: 16px; color: rgb(54, 96, 146);">CNAS实验室认可咨询服务：</span></strong></span></p><p style="text-align: center;"><img width="50%" style="margin: auto;" src="`+jieshao+`" /></p><p><span style="color: rgb(0, 0, 0);"><strong><span style="background: rgb(255, 255, 255); color: rgb(89, 89, 89); font-family: arial, helvetica, sans-serif; font-size: 16px;"></span></strong></span></p><p style="text-align: left;"><span style="font-size: 16px; font-family: arial, helvetica, sans-serif; color: rgb(0, 0, 0);"><strong><span style="font-family: arial, helvetica, sans-serif; font-size: 16px; color: rgb(54, 96, 146);">CNAS的定义：</span></strong></span></p><p><span style="color: rgb(0, 0, 0);"></span></p><p><span style="color: rgb(0, 0, 0);">CNAS (China National AccreditationService for Conformity 
Assessment)是中国合格评定国家认可委员会的简称。它是根据《中华人民共和国认证认可条例》的规定，国家认证认可监督管理委员会批准设立并授权的国家认可机构，统一负责对认证机构、实验室和检查机构等相关机构的认可工作。</span><a target="_self" style="text-decoration: underline; color: rgb(0, 0, 0);"><span style="color: rgb(0, 0, 0);">CNAS实验室认可</span></a><span style="color: rgb(0, 0, 0);">是对实验室有能力进行规定类型的检测和(或)校准所给予的一种正式承认。</span></p><p style="text-align: left;"><span style="font-size: 16px; font-family: arial, helvetica, sans-serif; color: rgb(0, 0, 0);"><strong><span style="font-family: arial, helvetica, sans-serif; font-size: 16px; color: rgb(54, 96, 146);">CNAS实验室认可的条件：</span></strong></span></p><p><span style="color: rgb(0, 0, 0);">（1）具有明确的法律地位，其活动应符合国家法律法规的要求。</span></p><p><span style="color: rgb(0, 0, 0);">（2）按CNAS-CL01建立了符合认可要求的管理体系，正式、有效运行6个月以上；</span></p><p><span style="color: rgb(0, 0, 0);">（3）进行过完整的内审和管理评审,并能达到预期目的；</span></p><p><span style="color: rgb(0, 0, 0);">（4）申请的技术能力满足CNAS- RL02《能力验证规则》的要求，即只要可能，每个领域至少参加一次能力验证活动或测量审核，并获得满意结果；</span></p><p><span style="color: rgb(0, 0, 0);">（5）具有开展申请范围内的检测/校准活动所需的资源，设备、设施、场地、人员等要求能否满足要求；</span></p><p><span style="color: rgb(0, 0, 0);">（6）遵守CNAS认可规则、认可政策等有关规定，包括支付认可申请费用。</span></p><p><span style="font-size: 16px; font-family: arial, helvetica, sans-serif; color: rgb(0, 0, 0);"><strong><span style="font-size: 16px; color: rgb(54, 96, 146); font-family: 宋体;"></span></strong></span></p><p><span style="font-family: arial, helvetica, sans-serif; font-size: 16px; color: rgb(0, 0, 0);"></span></p><p style="text-align: left;"><a  target="_self"><span style="font-size: 16px; font-family: arial, helvetica, sans-serif; color: rgb(0, 0, 0);"><strong><span style="font-family: arial, helvetica, sans-serif; font-size: 16px; color: rgb(54, 96, 146);">CNAS资质认可</span></strong></span></a><span style="font-size: 16px; font-family: arial, helvetica, sans-serif; color: rgb(0, 0, 0);"><strong><span style="font-family: arial, helvetica, sans-serif; font-size: 16px; color: rgb(54, 96, 146);">流程：</span></strong></span></p><p><span style="color: rgb(0, 0, 0);">1、网上注册(发验证码到邮箱，审核一般2个工作日);</span></p><p><span style="color: rgb(0, 0, 0);">2、网上申报按要求填写相关文件(申报能力附表中英文、授权签字人中英文签名及简历、仪器设备配置表、质量手册、程序文件、内审报告、管理评审报告、典型报告，试验场地证明、人员劳动合同、社保证明、实验室人员一览表、典型报告、测量不确定度报告、能力验证/测量审核报告等);</span></p><p><span style="color: rgb(0, 0, 0);">3、网上后台会显示进度，文审通过后下受理通知书，盖章回传;</span></p><p><span style="color: rgb(0, 0, 0);">4、申请书、附表及附件邮寄到认可七处;</span></p><p><span style="color: rgb(0, 0, 0);">5、安排现场评审;</span></p><p><span style="color: rgb(0, 0, 0);">6、整改时间一般为两个月;</span></p><p><span style="color: rgb(0, 0, 0);">7、获准认可，邮寄证书。</span></p><p style="text-align: center;"><img width="50%" style="margin: auto;" src="`+liucheng+`" /></p><p style="text-align: left;"><span style="font-size: 16px; font-family: arial, helvetica, sans-serif; color: rgb(0, 0, 0);"><strong><span style="font-family: arial, helvetica, sans-serif; font-size: 16px; color: rgb(54, 96, 146);">CNAS资质认可的作用和意义：</span></strong></span></p><p style="white-space: normal;"><span style="color: rgb(0, 0, 0);">1、表明具备了按相应认可准则开展检测和校准服务的技术能力；</span></p><p style="white-space: normal;"><span style="color: rgb(0, 0, 0);">2、增强市场竞争能力，赢得政府部门、社会各界的信任；</span></p><p style="white-space: normal;"><span style="color: rgb(0, 0, 0);">3、获得签署互认协议方国家和地区认可机构的承认；</span></p><p style="white-space: normal;"><span style="color: rgb(0, 0, 0);">4、有机会参与国际间合格评定机构认可双边、多边合作交流；</span></p><p style="white-space: normal;"><span style="color: rgb(0, 0, 0);">5、可在认可的范围内使用<a  target="_self" style="color: rgb(0, 0, 0); text-decoration: underline;"><span style="color: rgb(0, 0, 0);">CNAS国家实验室认可</span></a>标志和ILAC国际互认联合标志；</span></p><p style="white-space: normal;"><span style="color: rgb(0, 0, 0);">6、列入获准认可机构名录，提高知名度。</span></p>                        </div>
                    </div>
                </div>`
        };
    }

    return (
        <>
            <FloatButton.BackTop visibilityHeight={0}  style={{zIndex:9999999999999999}}/>
            {/*<div className="warp is_PC">*/}
            {/*    <div className="vub">*/}
            {/*        /!*<div className="vub_A">*!/*/}
            {/*        /!*    <ul>*!/*/}
            {/*        /!*        <li><a target="_blank">关于我们</a></li>*!/*/}
            {/*        /!*        <li><a target="_blank">联系我们</a></li>*!/*/}
            {/*        /!*    </ul>*!/*/}
            {/*        /!*</div>*!/*/}
            {/*        <div className="vub_B">联系电话： 18957441030</div>*/}
            {/*    </div>*/}
            {/*</div>*/}
            <div className="fixed is_PC"></div>
            <div className="all_width is_PC">

                <div className="warp">
                    <div className="header">
                         <div className="logo"><a href="#/ContentIndex" style={{float:"left",marginRight:15}}><img src={logoImg} height={108}/></a></div>
                        <div className="new_nav">
                           <ul>
                                <li><a href="#/ContentIndex">首页</a></li>
                                <li><a  href="#/cnas">CNAS认可</a></li>
                                <li><a  href="#/cma">CMA认定</a></li>
                                <li><a  href="#/fanghuo">防火检测</a></li>
                                <li><a  href="#/haishui">海水腐蚀</a></li>
                                <li><a  href="#/jingxiang">金相抛光布</a></li>
                                <li><a   href="#/about">关于我们</a></li>
                            </ul>
                        </div>

                        <div className="vub_B" style={{position:"fixed",top:"30px"}}>联系电话： 18957441030</div>
                    </div>
                </div>
            </div>
            <div style={{position:'relative'}}>
                {/*<img src={bannerBG}/>*/}
                <img src={yemei} width={'100%'}/>
                <div style={{position:"absolute",top:'15%',left:'50px',fontSize:50,color:'#fff',fontWeight:"bold",width:1000,textAlign:"center"}}>
                    <span>实验室CNAS认可/17025体系</span><br />
                    <span>上门服务 保证一次性通过</span><br />
                    <span style={{fontWeight:100,fontSize:31}}>准则宣贯、文件编制、内部审核、管理评审、质量记录、技术记录。</span>
                </div>
            </div>
            <div className={'service-details'} >
                <Affix offsetTop={top}>
                    <div className="l-box" >
                        <div className="s-plate">
                            <div className="d-nav">
                                <ul>
                                    <li onClick={event => scroll(531)}>
												<span>
													<i></i>CNAS实验室认可咨询服务</span>
                                    </li>
                                    <li onClick={event => scroll(872)}>
												<span>
													<i></i>CNAS的定义</span>
                                    </li>
                                    <li className=""  onClick={event => scroll(987)}>
												<span>
													<i></i>CNAS实验室认可的条件												</span>
                                    </li>
                                    <li className="" onClick={event => scroll(1272)}>
												<span>
													<i></i>CNAS资质认可流程</span>
                                    </li>
                                    <li className="" onClick={event => scroll(2135)}>
												<span>
													<i></i>CNAS资质认可的作用和意义</span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </Affix>
                <div className={'r-box'}>
                    <div dangerouslySetInnerHTML={createMarkup()}/>
                </div>
            </div>

            <img src={xia} width={'100%'} style={{zIndex:999,position:"relative",marginTop:80,display:"block"}}/>
             <div className="all_fnav is_PC" style={{zIndex:999,position:"relative"}}>
                 <div style={{background:'#fff',height:80}}></div>
                <div className="warp">
                    <div className={'b'}>
                        <img src={logo22} height={108} style={{float:"left"}}/>
                        <div style={{float:"right",lineHeight:'108px',fontSize:'26px',paddingRight:40}}>致力于我国实验室建设、 认证、 扩项、 监督评审、 一站式解决方案</div>
                    </div>
                    <div className="Fanya_footer_nav" style={{color:'#FFF'}}>
                        <ul>
                            <li>
                                
                                <div className="Fanya_footer_nav_TT">CMA资质认定</div>
                                <div className="Fanya_footer_sub">
                                    <dl>
                                        <dt>检验检测机构CMA资质认定</dt>
                                        <dt>机动车检验机构CMA资质认定</dt>
                                        <dt>司法鉴定机构CMA资质认定</dt>
                                        <dt>刑事技术机构CMA资质认定</dt>
                                    </dl>
                                </div>
                            </li>
                            <li><div className="Fanya_footer_nav_TT">CNAS认证认可</div>
                                <div className="Fanya_footer_sub">
                                    <dl>
                                        <dt>ISO17025检测/校准实验室CNAS认可</dt>
                                        <dt>ISO17020检验机构CNAS认可</dt>
                                        <dt>ISO15189医学实验室CNAS认可</dt>
                                        <dt>DILAC国防实验室认可</dt>
                                    </dl>
                                </div>
                            </li>
                            <li style={{marginRight:15}}>
                                <div className="Fanya_footer_nav_TT">联系我们</div>
                                <div className="Fanya_footer_sub">
                                    <dl>
                                        <dt>电话：0574-87636695</dt>
                                        <dt>认证热线：18957441030（胡老师）</dt>
                                        <dt>地址：宁波市高新区检验检测园冬青路258号A幢</dt>
                                        <dt></dt>
                                    </dl>
                                </div>
                            </li>
                            <li>
                                <div className="Fanya_footer_sub" style={{position:"relative"}}>
                                    <img src={weixing} width={160} />
                                    <div style={{background:'red',borderRadius:16,lineHeight:'32px',textAlign:"center",width:160,marginTop:10}}>扫码咨询</div>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div className="all_Fanya_copyright">
                <div className="warp">
                    <div className="Fanya_copyright">版权所有 ◎ 浙江安鉴检测认证服务有限公司 <a
                        href="http://beian.miit.gov.cn/" target="_blank">浙ICP备2024103308号-1</a></div>
                </div>
            </div>
        </>
    );
};
export default App;
